import { render } from "./certification.vue?vue&type=template&id=257bf8ae"
const script = {}

import "./certification.vue?vue&type=style&index=0&id=257bf8ae&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__